import type { World } from 'koota';
import { MAX_PLAYERS } from '../../core/players';
import { MatchState, PartyState } from '../traits';

export const MATCH_WIN_KEYS = [
  'wins0',
  'wins1',
  'wins2',
  'wins3',
  'wins4',
  'wins5',
  'wins6',
  'wins7',
] as const;
export const PARTY_SCORE_KEYS = [
  'score0',
  'score1',
  'score2',
  'score3',
  'score4',
  'score5',
  'score6',
  'score7',
] as const;

export function matchWinScores(world: World): number[] {
  const match = world.get(MatchState);
  return Array.from({ length: MAX_PLAYERS }, (_, slot) => match?.[MATCH_WIN_KEYS[slot]!] ?? 0);
}

/** Missing scores are zero, including recovery packets made before a later seat joined. */
export function restoreMatchWins(world: World, wins: number[]): void {
  const match = world.get(MatchState);
  if (!match) return;
  for (let slot = 0; slot < MAX_PLAYERS; slot++) {
    const score = wins[slot] ?? 0;
    match[MATCH_WIN_KEYS[slot]!] = Number.isFinite(score) ? Math.max(0, Math.floor(score)) : 0;
  }
  world.set(MatchState, match);
}

export function partyControlScores(world: World): number[] {
  const party = world.get(PartyState);
  return PARTY_SCORE_KEYS.map((key) => party?.[key] ?? 0);
}
